import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import emptyBox from '../img/EmptyBox.png';
import { useTranslation } from "react-i18next";

const LogoImage = styled('img')(({ theme }) => ({
  width: '230px',
  height: 'auto',
  [theme.breakpoints.down('sm')]: {
    width: '150px',
  },
}));


function TeacherEvents() {

  const { t } = useTranslation();

  return (
    <div>
          {/* Header */}
          <Typography
            id="modal-title"
            variant="h5"
            component="h2"
            sx={{
              color: '#12344d',
              borderBottom: '1px solid #ddd',
              marginBottom: '20px',
              direction: 'rtl',
            }}
          >
            {t("School Events")}
          </Typography>

          {/* Content */}
          <Typography id="modal-content" variant="body1" sx={{display: 'flex', justifyContent: 'center',  alignItems: 'center',}}>
            <LogoImage src={emptyBox} alt={t("Logo")} /> 
          </Typography>
          <Typography sx={{
            display: 'flex', 
            justifyContent: 'center',  
            alignItems: 'center',   
            fontFamily: 'Arial',
            fontSize: '18px', 
            color: '#b0b0b0', 
            textAlign: 'center', 
            lineHeight: '1.5', 
            margin: '20px 0'
            }}> 
              {t("There are no events at the moment")}
            </Typography>
    </div>
  );
}

export default TeacherEvents;
